<template>
  <div class="overflow-y-auto p-4">
    <el-card
      class="rounded-lg border bg-card text-card-foreground shadow-2xs mb-6"
    >
      <div class="flex flex-col space-y-1.5 p-6">
        <h3 class="text-2xl font-semibold leading-none tracking-tight">
          Filters &amp; Search
        </h3>
      </div>
      <el-form label-position="top">
        <div class="p-6 pt-0">
          <div class="grid gap-4 md:grid-cols-6">
            <div class="md:col-span-2">
              <div class="flex flex-col gap-2">
                <label
                  class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Model Name
                </label>
                <DebounceInput
                  placeholder="Search model name"
                  v-model="searchName"
                  clearable
                >
                  <template #prepend>
                    <i class="el-icon-search"></i>
                  </template>
                </DebounceInput>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
    <el-card
      class="rounded-lg border bg-card text-card-foreground shadow-2xs"
    >
      <div class="flex flex-row justify-between items-center py-4">
        <div></div>
        <div>
          <el-button
            v-if="false"
            type="primary"
            icon="el-icon-plus"
            @click="handleAddModel()"
          >
            Model
          </el-button>
        </div>
      </div>
      <div class="p-0">
        <div class="relative w-full overflow-auto">
          <el-table
            v-loading="tableCtrl.state.loading"
            element-loading-background="rgba(24, 33, 48, 0.8)"
            :data="tableCtrl.state.tableData"
            style="width: 100%"
            :resizable="false"
          >
            <el-table-column type="expand">
              <template #default="{ row }">
                <div class="flex flex-col gap-4">
                  <div class="font-bold">Parameters</div>
                  <ModelParamList
                    :value="row.paramList"
                    :disabled="true"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" width="120" />
            <el-table-column prop="name" label="Name" width="120">
              <template slot-scope="scope">
                <div class="flex flex-row items-center">
                  <el-tooltip :content="scope.row.name" placement="top">
                    <span
                      class="flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      {{ scope.row.name }}
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="Description">
              <template slot-scope="scope">
                <el-tooltip
                  :content="scope.row.desc || 'N/A'"
                  placement="top"
                >
                  <div class="break-all">
                    {{ scope.row.desc || "N/A" }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              v-if="false"
              label="Actions"
              width="180"
              align="right"
              fixed="right"
            >
              <template slot-scope="scope">
                <ActionButtons
                  :actions="actions"
                  :item="scope.row"
                  @command="handleCommand"
                />
              </template>
            </el-table-column>
          </el-table>
          <div class="flex mt-4 justify-end">
            <el-pagination
              @size-change="(val) => tableCtrl.setPageSize(val)"
              @current-change="(val) => tableCtrl.setCurrentPage(val)"
              :current-page="tableCtrl.state.pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="tableCtrl.state.pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableCtrl.state.pagination.total"
            />
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import ActionButtons from "@/components/ActionButtons.vue";
import { TableController } from "@/controllers/TableController";
import BotSvg from "!!raw-loader!@/assets/bot.svg";
import BrainSvg from "!!raw-loader!@/assets/brain.svg";
import { getDashboardModels, deleteDashboardModel, getAgents } from "@/api";
import {
  EventLogLevel,
  EventLogStatus,
  enumValueToLabel,
  enumToOptions,
  AIAgentModel,
} from "@/enums";
import ModelParamList from "@/components/ModelParamList.vue";

export default {
  name: "AiAuditLogsModelList",
  components: {
    ActionButtons,
    ModelParamList,
  },
  emits: ["tabIndex"],
  data() {
    return {
      BotSvg,
      BrainSvg,
      tabIndex: 1,
      tableCtrl: new TableController({
        loadMethod: async (opt) => {
          const res = await getDashboardModels(opt);
          // 适配 TableController 需要的数据结构
          return { list: res, total: res.length };
        },
        autoLoad: true,
        isClientPaged: true,
        pageSize: 10,
        keyField: "id",
        queryParameters: {
          name: "",
        },
      }),
    };
  },
  computed: {
    AIAgentModel: () => AIAgentModel,
    EventLogLevel: () => EventLogLevel,
    EventLogStatus: () => EventLogStatus,
    actions: () => [
      {
        type: "button",
        label: "Chat",
        command: "chat",
        icon: "el-icon-message",
      },
      {
        type: "dropdown",
        label: "more",
        icon: "el-icon-more",
        items: [
          {
            label: "Edit",
            command: "edit",
            icon: "el-icon-edit",
          },
          {
            label: "Delete",
            command: "delete",
            icon: "el-icon-delete",
            color: "#F56C6C",
            divided: true,
          },
        ],
      },
    ],
    searchName: {
      get() {
        return this.tableCtrl.queryParameters.name.replace(/%/g, "");
      },
      set(val) {
        this.tableCtrl.queryParameters.name = `%${val}%`;
      },
    },
  },
  watch: {
    "tableCtrl.queryParameters": {
      deep: true,
      handler() {
        this.tableCtrl.filterData();
      },
    },
  },
  methods: {
    enumToOptions,
    enumValueToLabel,
    getAgents,
    async handleRefresh() {
      await this.tableCtrl.refresh();
    },
    async fetchData(params) {
      const res = await getDashboardModels(params);
      return Array.isArray(res) ? res : res?.data || [];
    },
    updateValue(value) {
      this.emit("input", value);
    },
    async handleAddModel() {
      const me = this;
      await me.handleEditModel(null, "create");
      me.$message.success("Model created successfully");
      await me.handleRefresh();
    },
    async handleCommand({ command, item }) {
      console.log(...arguments);
      const me = this;
      if (["create", "edit", "feedback"].includes(command)) {
        await me.handleEditModel(item, command);
      } else if (command === "chat") {
        await me.openChatDialog(item);
      } else if (command === "delete") {
        await me.handleDelete(item);
      }
      me.$message.success("Operation successful");
      await me.handleRefresh();
    },
    async handleDelete(item) {
      const me = this;
      await me.$confirm(
        `Are you sure you want to delete model "${item?.name}"?`,
        "Warning",
        {
          type: "warning",
        }
      );
      try {
        me.loading = true;
        await deleteDashboardModel(item.id);
        me.$message({
          type: "success",
          message: `Deleted model "${item.name}" successfully!`,
        });
      } finally {
        me.loading = false;
      }
    },
    async handleEditModel(item, command) {
      const me = this;
      // 首字母大写处理
      const cap = command
        ? command.charAt(0).toUpperCase() + command.slice(1)
        : "Edit";
      await me.$loaderWindow({
        title: `${cap} Model`,
        component: () => import("./ModelEditDialog.vue"),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: {
          modelId: item?.id,
        },
      });
    },
    handleChangeTab(index) {
      this.$emit("tabIndex", index);
    },
  },
};
</script>
